export default __webpack_public_path__ + "static/media/profile.5b3eab95.svg";